<div class='mat-calendar-header'>
  <button
    (click)='previousClicked("year")'
    class='mat-calendar-header-double-arrow'
    mat-icon-button
  >
    <mat-icon>keyboard_arrow_left</mat-icon>
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <button (click)='previousClicked("month")' mat-icon-button>
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <span class='mat-calendar-header-label'>{{ periodLabel }}</span>

  <button (click)='nextClicked("month")' mat-icon-button>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <button
    (click)='nextClicked("year")'
    class='mat-calendar-header-double-arrow'
    mat-icon-button
  >
    <mat-icon>keyboard_arrow_right</mat-icon>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
